export type FoodBenefitDistribution = {
  meal: number;
  food: number;
  mobility: number;
  culture: number;
  health: number;
  education: number;
  homeOffice: number;
  freeBalance: number;
  multi: number;
};

export const FOOD_BENEFIT_DISTRIBUTION_KEYS = [
  'meal',
  'food',
  'mobility',
  'culture',
  'health',
  'education',
  'homeOffice',
  'freeBalance',
  'multi',
] as const;

export const createEmptyFoodBenefitDistribution = (): FoodBenefitDistribution => {
  return FOOD_BENEFIT_DISTRIBUTION_KEYS.reduce((acc, key) => {
    acc[key] = 0;
    return acc;
  }, {} as FoodBenefitDistribution);
};

export type FoodBenefitRecord = FoodBenefitDistribution & {
  code: string;
  name: string;
  dependentsCount: number;
  feeCount: number;
  amount: number;
};

export type FoodBenefitParseTotals = {
  dependents: number;
  feeCount: number;
  amount: number;
  breakdown: FoodBenefitDistribution;
};

export type FoodBenefitParseResult = {
  records: FoodBenefitRecord[];
  totals: FoodBenefitParseTotals;
  orders: FoodBenefitOrder[];
};

export type FoodBenefitSourceFile = {
  name: string;
  size: number;
  contentType: string | null;
};

export type FoodBenefitImportRecordPreview = FoodBenefitRecord & {
  collaboratorId: string | null;
};

export type FoodBenefitImportTotals = FoodBenefitParseTotals;

export type FoodBenefitAuditItem = {
  beneficiaryName: string;
  beneficiaryCpf?: string | null;
  value: number | null;
  reason: string;
  type: 'not_found' | 'inactive';
};

export type FoodBenefitImportDocument = {
  id: string;
  provider: string;
  billingPeriod: string | null;
  totals: FoodBenefitImportTotals;
  sourceFiles: FoodBenefitSourceFile[];
  recordsPreview: FoodBenefitImportRecordPreview[];
  orders?: FoodBenefitOrder[];
  audit?: FoodBenefitAuditItem[];
  createdAt: Date | null;
  createdByUid: string;
  createdByEmail: string | null;
  createdByName: string | null;
};

export type CreateFoodBenefitImportPayload = {
  billingPeriod: string | null;
  totals: FoodBenefitImportTotals;
  sourceFiles: FoodBenefitSourceFile[];
  recordsPreview: FoodBenefitImportRecordPreview[];
  orders?: FoodBenefitOrder[];
  audit?: FoodBenefitAuditItem[];
};

export type FoodBenefitCodeAssignment = {
  code: string;
  collaboratorId: string;
};

export type FoodBenefitOrder = {
  orderId: string;
  company: string | null;
  status: string | null;
  totalAmount: number;
  orderDate: string | null;
  fileName?: string | null;
};
